import { translate } from '../../../../../i18n'
import { GContainer, MiddleGItem } from '../../grids'

// お子さま名
const ChildName = (props: {childName: string}) => (
  <GContainer>
    <MiddleGItem xs={5} md={4}>
      {translate('facilityLotteryReservationUpdateSelection.label.childName')}
    </MiddleGItem>
    {props.childName}  
  </GContainer>
)
export default ChildName